export default {
  GET_ROLE_LIST: state => state.roleList,
  GET_MODULE_LIST: state => state.moduleList,
  GET_MODULE_LIST_CHILDREN: state => state.moduleListChildren,
}